import { useSwaggerlessContext } from 'Context/SwaggerlessContext';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import { validateType } from 'Helpers/Validation';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import ShadowDOM from 'Components/UI/ShadowDOM';
import { Typography } from '@material-ui/core';
import LoadingIndicator from '../../../../../../../UI/LoadingIndicator';

const styles = theme => ({
  root: {},
  addressLine: {
    display: 'flex',
    alignItems: 'baseline',
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  addressTitle: {
    marginRight: theme.spacing(0.5),
  },
});

const EmailViewer = ({
  classes, className, id,
}) => {
  const { fetchRelatedEmail } = useSwaggerlessContext();
  const [emailInfo, setEmailInfo] = useState({});
  const [loading, setLoading] = useState(false);

  const fetchEmail = async () => {
    setLoading(true);
    try {
      const { data: { attributes, meta } } = await fetchRelatedEmail(id);
      const { att } = validateType(attributes, meta);
      const { to, from, htmlContent } = att;
      setEmailInfo({
        to,
        from,
        content: htmlContent || 'No content returned',
      });
    } catch (e) {
      displayErrorMessage(e, 'Could not fetch email');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmail();
  }, [id]);

  const { to, from, content } = emailInfo;
  return (
    <div className={classNames(classes.root, className)}>
      {loading
        ? (<LoadingIndicator />)
        : (
          <div>
            <div className={classes.addressLine}>
              <Typography
                variant="h5"
                color="primary"
                className={classes.addressTitle}
              >
                From:
              </Typography>
              <span>{from}</span>
            </div>
            <div className={classes.addressLine}>
              <Typography
                variant="h5"
                color="primary"
                className={classes.addressTitle}
              >
                To:
              </Typography>
              <span>{to?.join(', ')}</span>
            </div>
            <ShadowDOM name={`email-${id}`}>
              <RichTextDisplay content={content} />
            </ShadowDOM>
          </div>
        )
      }
    </div>
  );
};

EmailViewer.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
};

EmailViewer.defaultProps = {
  className: '',
};

export default withStyles(styles)(EmailViewer);
